import { useMsal } from '@azure/msal-react'
import { Box, Flex, HStack, Image, Spacer, Stack, Text } from '@chakra-ui/react'
import moment from 'moment'
import React, { useState } from 'react'
import { AiFillPrinter } from 'react-icons/ai'

export default function PrintPickUp({ SingleData, onClick }) {

    console.log("single data", SingleData)

    const {instance} = useMsal();
    const currentAccount = instance.getActiveAccount();
    console.log("currentAcc", currentAccount);

  
    const [Hide, setHide] = useState(false);

    const printNow = () => {
        setHide(true)

        setTimeout(() => {
            window.print()
            
        }, 1000);
        setTimeout(() => {
            setHide(false)


        }, 2000);
    }
    return (
        <Box mx={"6%"} py="32px">

            <HStack>
                <Image src='/logo.jpg' width={"10%"} />
                <Spacer />
                {
                    !Hide && (

                        <Text cursor={"pointer"} fontSize={"20px"} fontWeight="500" onClick={onClick}>{"<"} Back </Text>
                    )
                }
            </HStack>
            <Text mt="10px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Ims Print Out</Text>

            <HStack>
                <Stack spacing={"10px"}>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Ticket No: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.ticket} </Text>
                    </HStack>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Print Date: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{moment(Date.now()).format("DD/MM/YYYY")} </Text>
                    </HStack>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Time Stamp: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{moment(SingleData[0]?.requestdate).format("DD/MM/YYYY")} </Text>
                    </HStack>
                </Stack>
                <Spacer />
                {
                    !Hide && (

                        <HStack fontSize={"20px"} cursor="pointer" onClick={printNow}>
                            <Box><AiFillPrinter /></Box>
                            <Text color="#fff" bgColor="navy" fontSize={"14"} px="8px" py="3px" rounded="8px">Print</Text>
                        </HStack>
                    )
                }
            </HStack>
            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Receiver's Details</Text>

            <Stack spacing={"10px"} mx="20%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Name: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.staffname} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">StaffNo: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.staffid} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Office: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.department} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Receiving Dept.: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.department} </Text>
                </HStack>
            </Stack>

            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Product Details</Text>
            <Stack spacing={"10px"} mx="20%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Item description: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.productname} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Code: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.productshelf} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Quantity: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.qtyrequested} </Text>
                </HStack>

            </Stack>

            <Flex flexWrap={"wrap"} justifyContent="space-between" mt="10">
                <Box w={["100%", "45%"]}>
                    <Text fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Issued by</Text>
                    <Stack spacing={"10px"} mx="5%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Name of Admin Store Personnel: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{currentAccount.name} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Staff email: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{currentAccount.username} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Signature: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">..................... </Text>
                        </HStack>

                    </Stack>
                </Box>
                <Box w={["100%", "45%"]}>
                    <Text fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Picked by</Text>
                    <Stack spacing={"10px"} mx="5%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Name of Staff: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.staffname} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Staff Id: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData[0]?.staffid} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Signature: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">..................... </Text>
                        </HStack>

                    </Stack>
                </Box>

            </Flex>


        </Box>
    )
}
